export default {
  
  //Serbia sr(languagecode) RS(countrycode) Cрбија / Cрпски
  LandingPage: {
    intro_sub:
      'Daj novu šansu ambalažnom otpadu i učestvuj u zaštiti životne sredine.',
    title: 'Samsung Upcycle-Packaging',
    sequence1_1: 'Pridruži nam se u smanjenju otpada',
    sequence1_2:
      'za održivost životne sredine i od proizvod ambalaže napravi neke korisne stvarčice. U nastavku pogledaj kako da počneš.',
    sequence2_1: 'Predstavljamo Samsung Upcycle-Packaging',
    sequence2_2:
      'Kutija od proizvod posebno je napravljena tako da se može ponovo upotrebiti, čime dajemo svoj doprinos zaštiti životne sredine. Napravi korisne predmete za kuću koristeći ambalažu svog proizvod.',
    sequence3_1: 'Prati tačkice odštampane na ambalaži',
    sequence3_2:
      'Iseci ambalažu po uputstvu i sastavi neke zanimljive stvari.',
    sequence4_1: 'Izaberi predmet koji želiš da napraviš',
    sequence4_2:
      'Skroluj nadole i izaberi model svog proizvod koji je napisan na kutiji. Onda pronađi opciju za predmet koji te zanima i sastavi ga.',
    selectBox: 'Izaberi svoj proizvod',
    moreActivity:
      "Za više informacija o Samsung aktivnostima održivosti",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/al/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/al/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/al/sustainability/overview/',
    footer: `
    Copyright© 2019 - 2021 Samsung. Të gjitha të drejtat e rezervuara`,
  },
  ProductPage: {
    selectDesign: 'Izaberi dizajn koji ćeš napraviti',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'TV konzola',
    StorageBox: 'Kutija za sitnice',
    MagazineRack: 'Držač časopisa',
    CatHouse: 'Kućica za mačke',
    CatTunnel: 'Tunel za mačke',
    BookShelf: 'Polica za knjige',
    DeskShelf: 'Polica za sto',
    BlackRhino: 'Ugrožene životinje \n – crni nosorog', //update
    PolarBear: 'Ugrožene životinje \n – polarni medved', //update
    SeaTurtle: 'Ugrožene životinje \n – morska kornjača', //update
    TheRider: 'Konjić', //update
    Kibe: 'Stepeničasta polica sa fiokama', //update
    Tessellate: 'Modularni trouglovi', //update
    Twist: 'Tvist korpa', //update
    AlexCouchArmTable: 'Stočić Alex za \n rukohvat kauča', //update
    BlastOffClubHouse: 'Kućica kao raketa', //update
    KinokoTable: 'Stočić kao pečurka', //update
    Magnuss: 'Magnuss sto', //update
    GIO: 'Multifunkcionalni stalak', //update
    PostCardPlanter: 'Stoni držač slika', //update
    SneakerRack: 'Polica za obuću', //update
    TheSoban: 'Niski stočić', //update
    ToolBox: 'Kutija za alat', //update
    DeskStationary: 'Kutija za kancelarijski pribor',
    CoinBank: 'Kasica',
    MobileScanner:'Postolje za telefon',
    TabletScanner:'Postolje za tablet',
    PetStairs:'Степенице за кућне љубимце',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'minuta',
    all:'ALL',
    in: 'u',
    inOnly: 'u samo',
    allBoxSize: 'Sve veličine kutija',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'uputstvima',
    prepare: 'Pripremi kutiju',
    LetsDesign: "Hajde da dizajniramo",
    drawParts: 'Nacrtaj delove na kutiji',
    note1: 'Iscrtane oznake se mogu razlikovati po državama i veličinama',
    note2: 'Prvo skiciraj ceo crtež tako da se uklopi u površinu kutije',
    numberSpace: 'broj = razmaci između tačkica',
    diagonal: 'dijagonala',
    LEFT: 'LEVO (deo)',
    RIGHT: 'DESNO (deo)',
    TOP: 'GORE (deo)',
    TOP1: 'GORE (deo) 1',
    TOP2: 'GORE (deo) 2',
    BACK: 'POZADI (deo)',
    MIDDLE: 'SREDNJI (dio)',
    MIDDLE2: 'SREDNJI (dio) 2',
    BOTTOM: 'DOLE (deo)',
    FRONT: 'NAPRED (deo)',
    SIDE: 'STRANA (deo)',
    secondSIDE: 'DRUGA STRANA (deo)',
    secondSIDE1: 'DRUGA STRANA (deo) 1',
    secondSIDE2: 'DRUGA STRANA (deo) 2',
    LEG: 'NOGA (deo)', //update
    JOINT: 'SASTAV (deo)', //update
    FACE: 'LICE (deo)', //update
    DRAWERBOTTOM: 'DNO FIOKE (deo)', //update
    DRAWERSIDE: 'BOČNA STRANA FIOKE (deo)', //update
    NOSE: 'NOS (deo)', //update
    HANDLE: 'RUČICA (deo)', //update
    BOTTOMSIDE: 'DONJA STRANA (deo)', //update
    TOPSIDE: 'GORNJA STRANA (deo)', //update
    WING: 'KRILO (deo)', //update
    cutAndAssemble: "Hajde da isečemo i sastavimo",
    beCareful: 'Pazi da se ne povrediš tokom sečenja',
    cutOutParts: 'Iseci delove',
    assemble: 'Sastavi',
    Assemblyguide: 'Uputstvo za sastavljanje', //update
    fold: 'Primer presavijanja',
    foldGuide: 'Delove možeš lakše saviti ako ih postaviš na ivicu nameštaja',
    foldGuideDezeen:
      'Pritisni istakanu liniju na kartonu alatkom za savijanje nekoliko puta kako bi se karton lakše presavio', //update
    glue: 'Lepak ili lepljivu traku pažljivo rasporedi po površini', //update
    cable: 'Učvrsti sve nekom žicom ili kanapom dok se ne zalepi', //update
    done: 'Gotovo!',
    goBack: 'Vrati se na glavni meni',
  },
  CautionPage: {
    CAUTION: 'UPOZORENJE',
    needItem: 'Biće vam potrebno sledeće',
    children: 'Deca moraju biti pod nadzorom odraslih',
    mat:
      'Na pod stavite zaštitu kako se tokom procesa ne bi oštetio',
    doNotPutHeavyThing:
      'Nemojte stajati niti sedeti na ovim komadima nameštaja i nemojte pokušavati da na njih stavljate teške stvari',
    doNotThrow:
      'Ne bacajte i ne šutirajte nameštaj ni prema čemu, uključujućiljude i životinje',
    stayAwayFlame: 'Držite dalje od izvora plamena',
    stayAwayWater: 'Ne držite ih blizu vode ili u vlažnim uslovima',
    mayDamaged: '* TV kutija se može oštetiti tokom transporta',
    companyDoestResponsible:
      '* Kompanija ne preuzima odgovornost za lom ili povredu tokom ovog rada',
    cannotBeReturned:
      '* Proizvod čija je kutija oštećena ne može biti vraćen pod izgovorom nekvaliteta',
    understand: 'U redu, razumem',
  },
  PrivacyPolicy: {
    title: 'Privacy policy',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        'U odnosu na našu prethodnu ambalažu, upotrebili smo manje papira i mastila za proizvodnju većine naše TV ambalaže, čime smo se podigli još jedan stepenik više u našoj posvećenosti održivosti',
      text2:'',
      text2_special:
        '(* Gorenavedeno se ne odnosi na neke modele uključujući Lifestyle televizore)',
      text3: 'Izaberi donje tastere da otkriješ više',
    },
    greenIn: {
      title: 'Going Green u TV ambalaži',
      subtitle1: 'Potraži informacije o proizvodu',
      subtitle2: 'Ponovna upotreba eko-ambalaže',
      desc: 'Za više informacija potraži naziv modela',
      descM: '* Slikaj broj TV modela',
      guide: 'naziv modela',
      button: 'Slikaj',
      button2: 'Pređi na sastavljanje predmeta',
      product_info: 'Informacije o proizvodu',
    },
    search: {
      guide: 'Pretraga..',
      noResult: 'Nema rezultata',
      more: 'VIŠE',
      search: 'Pretraga',
      retake: 'Ponovi',
      result: 'Rezultat',
    },
    photo: {
      guide1: 'Spusti naziv TV modela u kutiju',
      guide2: '(npr. Q800A, UT7000, RU7100, etc)',
    },
  },
  searchCountrySelect: 'Izaberi državu za pretragu'
};
